import React, { PropsWithChildren } from "react";
import { useLocation } from "react-router";
import { matchRoutes } from "react-router-dom";
import PwaInstallBanner from "components/PwaInstallBanner";
import TopbarAdmin from "./TopbarAdmin";
import Topbar from "./Topbar/index";
import Footer from "./Footer";
import { cn } from "lib/utils";
import { ROUTES } from "routes";

const Main: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    const location = useLocation();
    const adminRoute = [{ path: `${ROUTES.ADMIN}/*` }];
    const matchedRouteAdmin = matchRoutes(adminRoute, location);
    const isCompaniesPage = location.pathname === ROUTES.COMPANIES;

    return (
        <React.Fragment>
            <PwaInstallBanner />
            {matchedRouteAdmin && matchedRouteAdmin?.length > 0 ? <TopbarAdmin /> : <Topbar />}
            <div className={cn(isCompaniesPage && "bg-slate-950")}>
                <main className="min-h-[calc(100vh-64px)]">{children}</main>
                {matchedRouteAdmin && matchedRouteAdmin?.length > 0 ? null : <Footer />}
            </div>
        </React.Fragment>
    );
};

export default Main;
